import { useQuery } from "@tanstack/react-query";
import { api } from "lib/api";

function actividadesPublicasKey() {
  return ["main", "actividades", "public"];
}

function actividadNivelPublicaKey(nivelId) {
  return ["main", "actividades", "public", "nivel", nivelId];
}

export function useMainActividadesPublicas(enabled = true) {
  return useQuery({
    queryKey: actividadesPublicasKey(),
    queryFn: () => api("/public/actividades"),
    enabled,
    staleTime: 60_000,
  });
}

export function useMainNivelActividadesPublicas(nivelId, enabled = true) {
  return useQuery({
    queryKey: actividadNivelPublicaKey(nivelId || ""),
    queryFn: () => api(`/public/actividades/niveles/${nivelId}`),
    enabled: enabled && !!nivelId,
    staleTime: 60_000,
  });
}
